import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-statistics-evolution',
  templateUrl: './select-statistics-evolution.component.html',
  styleUrls: ['./select-statistics-evolution.component.scss']
})
export class SelectStatisticsEvolutionComponent implements  OnDestroy {

  public items: any[] = [
    { name: 'Promedio', value: 'avg' },
    { name: 'Cierre de Mes', value: 'end' }
  ];

  public statisticEvolutionSelected: any = [];
  public ngxDisabled = true;
  statisticEvolutionSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.statisticEvolutionSelected$ = sharedService.sharedStatisticEvolution.subscribe((statisticEvolutionSelected: string) => {
      if (this.statisticEvolutionSelected !== statisticEvolutionSelected) {
        this.statisticEvolutionSelected = statisticEvolutionSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.statisticEvolutionSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    // ngx-select may return the value directly or in an array
    let value = event;
    if (Array.isArray(event) && event.length > 0) {
      value = event[0];
    }
    if (value && typeof value === 'object' && value.value !== undefined) {
      value = value.value;
    }
    
    this.statisticEvolutionSelected = value;
    this.sharedService.nextStatisticEvolution = this.statisticEvolutionSelected;
  }

  isSelected(option: any): boolean {
    if (!this.statisticEvolutionSelected || 
        (Array.isArray(this.statisticEvolutionSelected) && this.statisticEvolutionSelected.length === 0) ||
        this.statisticEvolutionSelected === '' || 
        this.statisticEvolutionSelected === null ||
        this.statisticEvolutionSelected === undefined) {
      return false;
    }
    
    let selectedValue: any;
    if (Array.isArray(this.statisticEvolutionSelected)) {
      if (this.statisticEvolutionSelected.length === 0) {
        return false;
      }
      selectedValue = this.statisticEvolutionSelected[0];
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    } else {
      selectedValue = this.statisticEvolutionSelected;
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    }
    
    return option.value === selectedValue;
  }

}
